export const selectIssuesValidator = (values) => {
  const errors = {};

  const atLeastOneChecked = values.issues?.some((i) => i.isChecked);

  if (!atLeastOneChecked) {
    errors.selectedIssues = 'You have to select at least one Issue';
  }

  return errors;
};
